import "../css/component/MobileHeader.scss";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import ImgLogo02 from "../assets/img/common/logo_02.png";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";

interface MobileHeader {
  data: Array<{
    name: string;
    href: string;
    children: Array<{
      name: string;
      href: string;
    }>;
  }>;
}

const MobileHeaderWrapper = styled.header`
  display: none;
  height: 60px;
  top: 0;
  left: 0;
  text-align: center;
  width: 100%;
  z-index: 999;
  background-color: #00273d;
  position: fixed;

  @media screen and (max-width: 750px) {
    display: block;
    text-align: left;
  }
`;
const Logo = styled.img`
  display: inline;
  width: 100px;
  cursor: pointer;
  margin-top: 10px;

  @media screen and (max-width: 750px) {
    margin-left: 18px;
  }
`;

const MobileHeaderButtonWrapper = styled.div`
  display: inline-block;
  position: absolute;
  right: 20px;
  height: 100%;
  width: 40px;
  cursor: pointer;
  transform: scale(0.9);
`;
const MobileHamburgerButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  background: #00273d;
  border: none;
  outline: none;
  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 100%;
    top: 0;
    right: 0;
    background: gray;
    transition: all 0.3s linear;
  }
`;
const MobileHamburgerImage = styled.span`
  position: absolute;
  width: 35px;
  height: 4px;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 2px;
  overflow: hidden;
  transition: all 0.3s linear;
`;
const MobileHeaderList = styled.div`
  display: block;
  position: fixed;
  top: 60px;
  background-color: #003b5d;
  width: 100%;
`;
const MobileMainMenuWrapper = styled.ul`
  overflow: hidden;
  padding: 5px 0px;
  margin: 0px;
`;
const MobileMainMenu = styled.li`
  text-align: center;
  &:not(:last-of-type) {
    border-bottom: solid 1px #0f1936;
  }
`;
const MobileMainMenuLink = styled.a`
  display: block;
  transition: 0.3s;
  padding: 12px 0px 12px 0px;
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: ${(props) => (props.selected ? "#F7C967" : "#fff")};
`;
const MobileSubMenuWrapper = styled.ul`
  z-index: 1;
  text-align: center;
  background: #154c6b;
  padding: 0;
  width: 100%;
`;
const MobileSubMenu = styled.li`
  border-bottom: 0.7px solid #1f3153;
  &:last-of-type {
    border-bottom: none;
  }
`;

const MobileSubMenuLink = styled.a`
  display: block;
  font-size: 14px;
  transition: 0.3s;
  padding: 10px 0;
  color: ${(props) => (props.selected ? "#F7C967" : "#eee")};
  &:hover {
    color: #fff;
  }
`;

export default function MobileHeader(props: MobileHeader) {
  const menuData = props.data;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isHamburgerOnClass, setIsHamburgerOnClass] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(0);

  const openHamburger = () => {
    if (isHamburgerOnClass) {
      setIsHamburgerOnClass(false);
    } else {
      setIsHamburgerOnClass(true);
      setSelectedMenu(-1);
    }
  };

  const openSubMenu = (menuNum: number) => {
    if (selectedMenu == menuNum) {
      setSelectedMenu(-2); // -1으로 바꾸면 URL 판단으로 바뀌므로 -2로 변경
    } else {
      setSelectedMenu(menuNum);
    }
  };

  return (
    <MobileHeaderWrapper id="header-mo">
      <Logo
        src={ImgLogo02}
        onClick={() => {
          navigate("/");
          window.scrollTo({ top: 0, left: 0 });
        }}
      />
      <MobileHeaderButtonWrapper onClick={openHamburger}>
        <MobileHamburgerButton id="hamburger" className={isHamburgerOnClass ? "on" : ""}>
          <MobileHamburgerImage />
          <MobileHamburgerImage />
          <MobileHamburgerImage />
        </MobileHamburgerButton>
      </MobileHeaderButtonWrapper>

      <MobileHeaderList className={`mobile-nav`}>
        <SlideDown className="dropdown-slidedown">
          {isHamburgerOnClass ? (
            <MobileMainMenuWrapper>
              {menuData.map((menu, idx) => {
                const isSelected = (selectedMenu == -1 && pathname.startsWith(menu.href)) || selectedMenu == idx;

                return menu.children ? (
                  <MobileMainMenu key={`main-menu${idx}`}>
                    <MobileMainMenuLink
                      selected={isSelected}
                      onClick={() => {
                        openSubMenu(idx);
                      }}
                    >
                      {menu.name}
                    </MobileMainMenuLink>
                    <MobileSubMenuWrapper>
                      <SlideDown className="dropdown-slidedown">
                        {isSelected
                          ? menu.children?.map((child, childIdx) => (
                              <MobileSubMenu key={`sub-menu${childIdx}`}>
                                <MobileSubMenuLink
                                  selected={pathname.startsWith(child.href)}
                                  onClick={() => {
                                    navigate(child.href);
                                    window.scrollTo({ top: 0, left: 0 });
                                    setIsHamburgerOnClass(false);
                                  }}
                                >
                                  {child.name}
                                </MobileSubMenuLink>
                              </MobileSubMenu>
                            ))
                          : null}
                      </SlideDown>
                    </MobileSubMenuWrapper>
                  </MobileMainMenu>
                ) : (
                  <MobileMainMenu key={`main-menu${idx}`}>
                    <MobileMainMenuLink
                      selected={isSelected}
                      onClick={() => {
                        setSelectedMenu(idx);
                        navigate(menu.href);
                        window.scrollTo({ top: 0, left: 0 });
                        setIsHamburgerOnClass(false);
                      }}
                    >
                      {menu.name}
                    </MobileMainMenuLink>
                  </MobileMainMenu>
                );
              })}
            </MobileMainMenuWrapper>
          ) : null}
        </SlideDown>
      </MobileHeaderList>
    </MobileHeaderWrapper>
  );
}
